var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaQs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.1667H10.0083",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 3.66667H4.99992C4.55789 3.66667 4.13397 3.84227 3.82141 4.15483C3.50885 4.46739 3.33325 4.89131 3.33325 5.33334V18.6667C3.33325 19.1087 3.50885 19.5326 3.82141 19.8452C4.13397 20.1577 4.55789 20.3333 4.99992 20.3333H14.9999C15.4419 20.3333 15.8659 20.1577 16.1784 19.8452C16.491 19.5326 16.6666 19.1087 16.6666 18.6667V7.83334L12.4999 3.66667Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 9.5C7.78323 8.94886 8.17056 8.48553 8.67753 8.19102C9.18449 7.89651 9.77884 7.78955 10.3567 7.88883C10.9345 7.98812 11.4591 8.28733 11.8387 8.73417C12.2182 9.18101 12.4287 9.74705 12.4333 10.3333C12.4333 12 9.93325 12.8333 9.93325 12.8333",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQs);
export default __webpack_public_path__ + "static/media/FAQs.3dba51b0f96be664d77f0f1c2b751f12.svg";
export { ForwardRef as ReactComponent };